<div *ngFor="let table of arrTable" class="elementinnerholder" [attr.data-docid]="table.docid">
    <div class="row">
        <!-- image top / left -->
        <div *ngIf="table.imagefileid > 0 && (table.imagepos == 1 || table.imagepos == 2 || table.imagepos == 4)" class="{{ table.imagepos == 1 ? 'col-xs-12' : 'col-sm-6' }}  {{ table.imagepos == 4 ? 'visible-xs' : '' }}">
            <div class="ii {{ table.imagepos == 1 ? 'imagetop' : ''  }} {{ table.imagepos == 2 ? 'imageleft' : ''  }} {{ table.imagepos == 4 ? 'imageright' : ''  }}">
                <a *ngIf="table.url != '' || table.urlwebpageid != ''" href="{{ table.urlwebpageid != '' ? table.urlwebpageid : table.url }}" target="{{ table.urlopentype == 2 ? '_blank' : '' }}">
                    <img [attr.src]="'/' + table.imagetitle + '.ci.'  + table.imagefileid + '.800.0.1.png'" alt="{{ table.imagetitle }}" class="img-responsive" />
                </a>
                <img *ngIf="table.url == '' && table.urlwebpageid == ''" [attr.src]="'/' + table.imagetitle + '.ci.'  + table.imagefileid + '.800.0.1.png'" alt="{{ table.imagetitle }}" class="img-responsive" />
            </div>
        </div>

        <!-- content -->
        <div class="{{ table.imagefileid > 0 && (table.imagepos == 2 || table.imagepos == 4) ? 'col-sm-6' : 'col-xs-12' }}">
            <div class="contentholder">
                <div class="title">
                    {{ table.contenttitle }}
                </div>
                <div class="content" [innerHTML]="table.description | safeHtml"> </div>
            </div>
        </div>

        <!-- image bottom / right -->
        <div *ngIf="table.imagefileid > 0 && (table.imagepos == 3 || table.imagepos == 4)" class="{{ table.imagepos == 3 ? 'col-xs-12' : 'col-sm-6' }}  {{ table.imagepos == 4 ? 'hidden-xs' : '' }}">
            <div class="ii {{ table.imagepos == 3 ? 'imagebottom' : ''  }} {{ table.imagepos == 4 ? 'imageright' : ''  }}">
                <a *ngIf="table.url != '' || table.urlwebpageid != ''" href="{{ table.urlwebpageid != '' ? table.urlwebpageid : table.url }}" target="{{ table.urlopentype == 2 ? '_blank' : '' }}">
                    <img [attr.src]="'/' + table.imagetitle + '.ci.'  + table.imagefileid + '.800.0.1.png'" alt="{{ table.imagetitle }}" class="img-responsive" />
                </a>
                <img *ngIf="table.url == '' && table.urlwebpageid == ''" [attr.src]="'/' + table.imagetitle + '.ci.'  + table.imagefileid + '.800.0.1.png'" alt="{{ table.imagetitle }}" class="img-responsive" />
            </div>
        </div>
    </div>
</div>

